import { render, staticRenderFns } from "./ProductPermission.vue?vue&type=template&id=f2fd6fc2"
import script from "./ProductPermission.vue?vue&type=script&lang=js"
export * from "./ProductPermission.vue?vue&type=script&lang=js"
import style0 from "./ProductPermission.vue?vue&type=style&index=0&id=f2fd6fc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports